import React from "react";

function SvgLinkPersonalIconNew(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={props.width}
      height={props.height}
      viewBox="0 0 50 50"
      color="currentColor"
    >
      <defs>
        <clipPath id="clip-Citizen_profile_2_1">
          <rect width="50" height="50" />
        </clipPath>
      </defs>
      <g
        id="Citizen_profile_2_1"
        data-name="Citizen profile 2 – 1"
        clipPath="url(#clip-Citizen_profile_2_1)"
      >
        <g id="energy" transform="translate(0 0)">
          <path
            id="Path_29260"
            data-name="Path 29260"
            d="M46.973,25a21.6,21.6,0,0,0-.386-4.005L50,19.043,42.676,6.357,39.252,8.315a22.113,22.113,0,0,0-6.928-4.02V0H17.676V4.295a22.115,22.115,0,0,0-6.928,4.02L7.324,6.206,0,18.892l3.414,2.1a20.963,20.963,0,0,0,0,8.011L0,31.108,7.324,43.794l3.424-2.109a22.116,22.116,0,0,0,6.928,4.02V50H32.324V45.705a22.115,22.115,0,0,0,6.928-4.02l3.424,2.109L50,31.108l-3.414-2.1A21.6,21.6,0,0,0,46.973,25ZM25,41.113A16.113,16.113,0,1,1,41.113,25,16.132,16.132,0,0,1,25,41.113Z"
            transform="translate(0 0)"
            fill="currentColor"
          />
          <path
            id="Path_29261"
            data-name="Path 29261"
            d="M134.184,121a13.184,13.184,0,1,0,13.184,13.184A13.2,13.2,0,0,0,134.184,121Zm1.389,22.436-2.778-.927,2.286-6.861h-5.859l3.573-10.717,2.778.927-2.286,6.861h5.859Z"
            transform="translate(-109.184 -109.184)"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  );
}
export default React.memo(SvgLinkPersonalIconNew);
